import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './features24.css'

const Features24 = (props) => {
  const [activeTab, setActiveTab] = useState(0)
  return (
    <div id="Sluzby" className="thq-section-padding">
      <div className="features24-container1 thq-section-max-width">
        <div className="features24-image-container">
          {activeTab === 1 && (
            <img
              alt={props.feature2ImgAlt}
              src={props.feature2ImgSrc}
              className="features24-image thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={props.feature3ImgAlt}
              src={props.feature3ImgSrc}
              className="features24-image1 thq-img-ratio-16-9"
            />
          )}
          <img
            alt={props.imageAlt1}
            src={props.imageSrc1}
            className="features24-image2"
          />
        </div>
        <div className="features24-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features24-tab-horizontal"
          >
            <div className="features24-divider-container">
              {activeTab === 0 && <div className="features24-container2"></div>}
            </div>
            <div className="features24-content">
              <h2 className="features24-feature1-title thq-heading-2">
                Numerologie
              </h2>
              <span className="thq-body-small">
                {props.feature1Description}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features24-tab-horizontal1"
          >
            <div className="features24-divider-container1">
              {activeTab === 1 && <div className="features24-container3"></div>}
            </div>
            <div className="features24-content1">
              <h2 className="features24-feature2-title thq-heading-2">
                Léčivé techniky
              </h2>
              <span className="thq-body-small">
                {props.feature2Description}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features24.defaultProps = {
  feature2Description:
    'V rámci své praxe využívám ajurvédu, tantru a jógu. Pracuji s kyvadlem, které slouží pro vysílání a přijímání energie, a tělovými svíčkami pro odhalení zdravotních potíží. Seznámím vás s vašimi čakrami a sestavím pro vás čakroskop. K vaší osobnosti přiřadím léčivé kameny a v rámci prevence zdraví vám poradím, jaké užívat bylinky a čaje.',
  imageAlt: 'image',
  feature1Description:
    'Pomocí rozboru vašeho data narození společně odhalíme vaše silné i slabé stránky, díky kterým můžete snáz čelit životním výzvám. Pomocí numerologie vám pomůžu i s rozborem vztahů, ať už partnerských, sourozeneckých, pracovních či přátelských. Sestavím vám váš numeroskop, který pomůže poodhalit výhledové tendence vašeho života.',
  feature2ImgSrc:
    'https://images.unsplash.com/photo-1555710908-25866c9c0cf6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  feature3ImgSrc:
    'https://images.unsplash.com/reserve/LJIZlzHgQ7WPSh5KVTCB_Typewriter.jpg?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  imageSrc: 'e53adc0f-cda0-4541-ab10-ac26faf5cd6e',
  feature3Description: 'Get personalized numerology readings',
  imageAlt1: 'image',
  imageSrc1: '/sulcova-ivana-400h.jpg',
  feature1ImgSrc:
    'https://images.unsplash.com/photo-1615498990748-97047cf9ae73?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  feature1Title: 'Numerologie',
  feature3Title: 'Personalized Readings',
  feature1ImgAlt: 'Numerologie',
  feature3ImgAlt: 'Personalized numerology readings',
  feature2ImgAlt: 'Life path number calculation',
  feature2Title: 'Léčivé techniky',
}

Features24.propTypes = {
  feature2Description: PropTypes.string,
  imageAlt: PropTypes.string,
  feature1Description: PropTypes.string,
  feature2ImgSrc: PropTypes.string,
  feature3ImgSrc: PropTypes.string,
  imageSrc: PropTypes.string,
  feature3Description: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc1: PropTypes.string,
  feature1ImgSrc: PropTypes.string,
  feature1Title: PropTypes.string,
  feature3Title: PropTypes.string,
  feature1ImgAlt: PropTypes.string,
  feature3ImgAlt: PropTypes.string,
  feature2ImgAlt: PropTypes.string,
  feature2Title: PropTypes.string,
}

export default Features24
